import { GetServerSideProps } from "next";

let sitemapBaseUrl: any = process.env.NEXT_PUBLIC_SITEMAP_BASE_URL;
// Ensure the base URL has a trailing slash
if (!sitemapBaseUrl.endsWith("/")) {
  sitemapBaseUrl += "/";
}

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  const sitemapIndex = `<?xml version="1.0" encoding="UTF-8"?>
    <?xml-stylesheet type="text/xsl" href="${sitemapBaseUrl}main-sitemap.xsl"?>
    <sitemapindex xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
        <sitemap>
            <loc>${sitemapBaseUrl}services-sitemap.xml</loc>
            <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>
        </sitemap>
        <sitemap>
            <loc>${sitemapBaseUrl}industries-sitemap.xml</loc>
            <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>
        </sitemap>
        <sitemap>
            <loc>${sitemapBaseUrl}software-solutions-sitemap.xml</loc>
            <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>
        </sitemap>
        <sitemap>
            <loc>${sitemapBaseUrl}pages-sitemap.xml</loc>
            <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>
        </sitemap>
        <sitemap>
            <loc>${sitemapBaseUrl}post-sitemap.xml</loc>
            <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>
        </sitemap>
        <sitemap>
            <loc>${sitemapBaseUrl}case-study-sitemap.xml</loc>
            <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>
        </sitemap>
        <sitemap>
            <loc>${sitemapBaseUrl}career-sitemap.xml</loc>
            <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>
        </sitemap>
    </sitemapindex>`;

  res.setHeader("Content-Type", "text/xml");
  res.write(sitemapIndex);
  res.end();

  return { props: {} };
};

export default function SitemapIndex() {}
